
import AxiosClient from "../../../services/axios.services";

class FormEvalCompetenciaQuestionsServices {
  getFormEvalCompetenciasQuestions = params =>
    AxiosClient.get("api/app/evaluacion_despliegue_preguntas_competencia/", {
      headers: { "Content-Type": "application/json" },
      params: params,
   });  
  getFormEvalCompetenciaQuestion = id =>
    AxiosClient.get(`api/app/evaluacion_despliegue_preguntas_competencia/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveFormEvalCompetenciaQuestion = data =>
    AxiosClient.post("api/app/evaluacion_despliegue_preguntas_competencia/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editFormEvalCompetenciaQuestion = (id, data) =>
    AxiosClient.put(
      `api/app/evaluacion_despliegue_preguntas_competencia/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteFormEvalCompetenciaQuestion = id =>
    AxiosClient.delete(`api/app/evaluacion_despliegue_preguntas_competencia/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new FormEvalCompetenciaQuestionsServices();

